import Raportet from "../Raportet/Raportet.jsx";
import { EmployeePayment } from "../EmployeeView/Payment/EmployeePayment";
import EmployeesView from "../EmployeeView/Personal/EmployeesView";
import DocumentationView from "../../Documentation/View/DocumentationView.jsx";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Tabs, Tooltip, Breadcrumb } from "antd";
import "./Tabs.scss";
import ClockIns from "../ClockIns/ClockIns.jsx";
import { DocumentationWarningIcon } from "../../../assets/icons";
import { API } from "../../../helpers/API/amplifyApi";
import dayjsTZ from "../../../utils/dayjs.js";
import { useSelector } from "react-redux";
import PunonjesitContext from "../store/PunonjesitContext.js";
import LoaderComponent from "../../commonComponents/LoadableComp/LoadableComp.jsx";
import { uniqBy } from "lodash";
import useEmployeeSpecsData from "../hooks/useEmployeeSpecsData";

const DynamicPunojsitView = () => {
  const navigate = useNavigate();
  const { employeeId } = useParams();
  const externalTab = useLocation()?.state?.tab || "";
  const externalKey = useLocation()?.state?.key || "";

  const { employees } = useSelector((state) => state.employeesList);
  const { accessToken } = useSelector((state) => state.accessToken);
  const { isDarkMode } = useSelector((state) => state.usersList);

  const [expiringDocs, setExpiringDocs] = useState(null);
  const [loading, setLoading] = useState(true);
  const [employee, setEmployee] = useState(null);
  const [documentation, setDocumentation] = useState([]);
  const [tab, setTab] = useState(externalTab || "Personale");
  const [activeKey, setActiveKey] = useState(externalKey || "1");
  const [templateModalVisible, setTemplateModalVisible] = useState(false);
  const [categoryConfiguration, setCategoryConfiguration] = useState({});

  const specsData = useEmployeeSpecsData(employeeId);

  const rowData = useMemo(() => {
    if (!employeeId || !employees) return null;

    return employees.find((emp) => emp?.employeeId === employeeId);
  }, [employeeId, employees]);

  //* maps all statuses with statusName, color and shows them at documentationView
  const populatedStatuses = useMemo(() => {
    if (!!Object.keys(categoryConfiguration)?.length) {
      return uniqBy(
        categoryConfiguration?.documentationsAvailable?.flatMap(
          ({ docStatuses = [] }) => docStatuses
        ),
        "statusName"
      ).map((el) => ({
        ...el,
        value: documentation.filter(
          ({ docStatus }) => docStatus === el?.statusName
        ).length,
      }));
    } else return [];
  }, [categoryConfiguration, documentation]);

  const onChange = (e) => {
    const dataTab = items?.find((el) => el?.key === e)?.label;
    setTab(dataTab);
    setActiveKey(e);
  };

  const getEmployeeDocs = () => {
    API.get("documentation", `/documentation`).then((r) => {
      let docs = r?.filter((el) => el?.recordId === employeeId);
      const expiring = docs?.find(({ expirationDate }) => {
        if (!expirationDate) return false;
        return (
          dayjsTZ(expirationDate).format("DD/MM/YYYY") >
          dayjsTZ().format("DD/MM/YYYY")
        );
      });
      setExpiringDocs(!!expiring);
      setDocumentation(docs);
      !docs?.length && setTemplateModalVisible(true);
    });
  };

  const dokumentacioneLabel = useMemo(() => {
    return (
      <span style={{ display: "flex", gap: 5 }}>
        {!!expiringDocs ? (
          <Tooltip
            title="Ky punonjës ka dokumente të cilat kanë skaduar."
            mouseEnterDelay={0.2}
            mouseLeaveDelay={0}
          >
            <DocumentationWarningIcon width={25} height={25} />
          </Tooltip>
        ) : (
          ""
        )}
        Dokumentacione
      </span>
    );
  }, [expiringDocs]);

  useEffect(() => {
    if (!!rowData) {
      setEmployee(rowData);
      getEmployeeDocs();
      setLoading(false);
    }
    // getEmployeeDocs reads employeeId + setters; re-run when rowData changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowData, employeeId]);

  const items = [
    {
      key: "1",
      label: "Personale",
      children: <EmployeesView />,
    },
    {
      key: "2",
      label: "Paga",
      children: <EmployeePayment />,
    },
    {
      key: "3",
      label: dokumentacioneLabel,
      children: <DocumentationView />,
    },
    {
      key: "4",
      label: "Lejet",
      children: <Raportet />,
    },
    {
      key: "5",
      label: "Oraret",
      children: <ClockIns />,
    },
  ];

  return (
    <PunonjesitContext.Provider
      value={{
        loading,
        employee,
        activeKey,
        setLoading,
        accessToken,
        setEmployee,
        documentation,
        getEmployeeDocs,
        setDocumentation,
        populatedStatuses,
        templateModalVisible,
        categoryConfiguration,
        setTemplateModalVisible,
        setCategoryConfiguration,
        specsData,
      }}
    >
      <LoaderComponent loading={loading}>
        <div className={`dynamic-punojsit-tabs ${isDarkMode ? "dark" : ""}`}>
          <Breadcrumb
            style={{ padding: 7 }}
            items={[
              {
                title: "Punonjesit",
                onClick: () => navigate("/punonjesit"),
              },
              {
                title: `${employee?.employeeFirstName || ""} ${
                  employee?.employeeLastName || ""
                }`.trim(),
              },
              { title: tab },
            ]}
          />
          <Tabs
            className="punojsit-tab"
            {...{
              onChange,
              activeKey,
              items,
            }}
          />
        </div>
      </LoaderComponent>
    </PunonjesitContext.Provider>
  );
};

export default DynamicPunojsitView;
